import { all } from 'redux-saga/effects';
import RehabSagas from './Rehab.sagas';
import ChoiceListSagas from './ChoiceList.sagas';

export default function* rootSaga() {
	yield all([...RehabSagas, ...ChoiceListSagas]);
}
